import cart from './routes/cart.js'
import general from './routes/general.js'
import order from './routes/order.js'
import reference from './routes/reference.js'
import user from './routes/user.js'

export default [
  cart,
  ...general,
  order,
  reference,
  ...user
]